import { render, staticRenderFns } from "./TransferIn.vue?vue&type=template&id=ec6db1b2&scoped=true"
import script from "./TransferIn.vue?vue&type=script&lang=js"
export * from "./TransferIn.vue?vue&type=script&lang=js"
import style0 from "./TransferIn.vue?vue&type=style&index=0&id=ec6db1b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec6db1b2",
  null
  
)

export default component.exports